export const FIRST_HUE = '5R';
